import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import API_BASE_URL from "../../../../Constants";
import { useAuth } from '../../../../contexts/AuthContext';

const TroubleCallList = () => {
    const [troubleCalls, setTroubleCalls] = useState([]);
    const [modalVisible, setModalVisible] = useState(false);
    const [pendingRequest, setPendingRequest] = useState(null); // Tracks the pending request (record ID)
    const [lockOwner, setLockOwner] = useState('');
    const navigate = useNavigate();

    const {user} = useAuth();

    const apiCall = async (url, options = {}) => {
        try {
            const response = await fetch(url, options);
            if (!response.ok) throw new Error(response.statusText);

            // Inspect the Content-Type header
            const contentType = response.headers.get('Content-Type');

            if (contentType && contentType.includes('application/json')) {
                return response.json(); // Parse as JSON
            } else {
                return response.text(); // Parse as text
            }
        } catch (error) {
            console.error('API call failed:', error);
            throw error; // Re-throw so it can be caught where the function is used
        }
    };



    const handleEdit = async (id) => {
        try {
            const response = await fetch(`${API_BASE_URL}/api/record/${id + "-troublecalllist"}/lock?user=${encodeURIComponent(user.username)}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include',
            });

            if (response.ok) {
                const data = await response.text();
                console.log(data);
                navigate(`/call-center/edit-troublecallentry/${id}`);
            } else if (response.status === 401) {
                const lockOwner = await response.text();
                console.log('Record is locked by:', lockOwner);
                setLockOwner(lockOwner);
                setPendingRequest(id + "-troublecalllist");
                setModalVisible(true);
            } else {
                throw new Error('Failed to lock record');
            }
        } catch (error) {
            alert('An error occurred: ' + error.message);
        }
    };

    const notifyUser = async (lockOwner, requester, recordId) => {
        try {
            await apiCall(`${API_BASE_URL}/api/notify/owner?lockOwner=${encodeURIComponent(lockOwner)}&requester=${encodeURIComponent(requester)}&recordId=${encodeURIComponent(recordId)}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include',
            });
            alert('Notification sent successfully');
            setPendingRequest(null); // Reset pending request after notification is sent
            setModalVisible(false);
        } catch (error) {
            console.error('Failed to send notification:', error.message);
        }
    };


    const handleRequestAccess = () => {
        if (pendingRequest) {
            notifyUser(lockOwner, user.username, pendingRequest);

            // subscribe to the particular record for updates about clear record lock

            // This is the api endpoint to subscribe to a record for updates about the record lock
            // @GetMapping("/sse/subscribe/record")
            // public SseEmitter subscribeToRecord(@RequestParam String recordId, @RequestParam String username) {

            // Complete the implementation of the subscribeToRecord method in the backend to allow the frontend to subscribe to the record for updates about the record lock

            const eventSource = new EventSource(`${API_BASE_URL}/sse/subscribe/record?recordId=${pendingRequest}&username=${user.username}`);
            eventSource.onmessage = ({ data }) => {
                // console.log('Received event:', event.data);
                // const { data } = event;
                // if (data === 'clear') {
                alert('Record [ ' + data + ' ]lock has been cleared');
                setPendingRequest(null);
                setModalVisible(false);
                eventSource.close();
                // }
            }

        }
    };

    // sad;asd;kask

    useEffect(() => {
        const fetchTroubleCalls = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}/api/callcenter/troublecalls/troubleCalls`, {
                    credentials: 'include',
                });
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const data = await response.json();
                setTroubleCalls(data);
            } catch (error) {
                console.error('Fetch error: ', error);
            }
        };

        fetchTroubleCalls();
        const intervalId = setInterval(fetchTroubleCalls, 5000);

        return () => clearInterval(intervalId);
    }, []);

    const handleDelete = async (id) => {
        try {
            const response = await fetch(`${API_BASE_URL}/api/callcenter/troublecalls/deleteTroubleCall/${id}`, {
                method: 'DELETE',
                credentials: 'include',
            });

            if (response.ok) {
                setTroubleCalls(troubleCalls.filter(troubleCall => troubleCall.troubleCallId !== id));
                alert('Trouble call deleted successfully');
            } else if (response.status === 401) {
                alert('Unauthorized. Please log in.');
                navigate('/login');
            } else {
                throw new Error('Failed to delete trouble call');
            }
        } catch (error) {
            console.error('Error deleting trouble call:', error);
            alert('An error occurred while deleting trouble call');
        }
    };

    return (
        <div className="mx-auto ml-4 h-screen w-full">
            <div className="flex justify-between items-center mb-4">
                <h2 className="text-2xl font-bold">Trouble Call List</h2>
            </div>
            <table className="min-w-full bg-white rounded-lg shadow-lg overflow-hidden border-2 border-gray-200">
                <thead className="bg-gray-200">
                    <tr>
                        <th className="px-4 py-2 text-left font-semibold text-gray-600">Trouble Call ID</th>
                        <th className="px-4 py-2 text-left font-semibold text-gray-600">Call Number</th>
                        <th className="px-4 py-2 text-left font-semibold text-gray-600">Building Site</th>
                        <th className="px-4 py-2 text-left font-semibold text-gray-600">Customer</th>
                        <th className="px-4 py-2 text-left font-semibold text-gray-600">Caller</th>
                        <th className="px-4 py-2 text-left font-semibold text-gray-600">Superintendent</th>
                        <th className="px-4 py-2 text-left font-semibold text-gray-600">Manager</th>
                        <th className="px-4 py-2 text-left font-semibold text-gray-600">Phone Number</th>
                        <th className="px-4 py-2 text-left font-semibold text-gray-600">Status</th>
                        <th className="px-4 py-2 text-left font-semibold text-gray-600">Priority</th>
                        <th className="px-4 py-2 text-left font-semibold text-gray-600">Problem Class</th>
                        <th className="px-4 py-2 text-left font-semibold text-gray-600">Sub</th>
                        <th className="px-4 py-2 text-left font-semibold text-gray-600">Dispatch Number</th>
                        <th className="px-4 py-2 text-left font-semibold text-gray-600">Actions</th>
                    </tr>
                </thead>
                <tbody className="text-gray-700">
                    {troubleCalls.map((troubleCall) => (
                        <tr key={troubleCall.troubleCallId} className="border-t">
                            <td className="px-4 py-2">{troubleCall.troubleCallId}</td>
                            <td className="px-4 py-2">{troubleCall.callNumber}</td>
                            <td className="px-4 py-2">{troubleCall.buildingSite}</td>
                            <td className="px-4 py-2">{troubleCall.customer}</td>
                            <td className="px-4 py-2">{troubleCall.caller}</td>
                            <td className="px-4 py-2">{troubleCall.superintendent}</td>
                            <td className="px-4 py-2">{troubleCall.manager}</td>
                            <td className="px-4 py-2">{troubleCall.phoneNumber}</td>
                            <td className="px-4 py-2">{troubleCall.status}</td>
                            <td className="px-4 py-2">{troubleCall.priority}</td>
                            <td className="px-4 py-2">{troubleCall.problemClass}</td>
                            <td className="px-4 py-2">{troubleCall.sub}</td>
                            <td className="px-4 py-2">{troubleCall.dispatchNumber}</td>
                            <td className="px-4 py-2">
                                <button className="text-blue-600 mr-2" onClick={() => handleEdit(troubleCall.troubleCallId)}>Edit</button>
                                <button className="text-red-600" onClick={() => handleDelete(troubleCall.troubleCallId)}>Delete</button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            {/* Modal for Requesting Access */}
            {modalVisible && (
                <div className="fixed z-10 inset-0 overflow-y-auto">
                    <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                        <div className="fixed inset-0 transition-opacity" aria-hidden="true">
                            <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
                        </div>

                        <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

                        <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
                            <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                                <div className="sm:flex sm:items-start">
                                    <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                                        <h3 className="text-lg leading-6 font-medium text-gray-900">
                                            Record Locked
                                        </h3>
                                        <div className="mt-2">
                                            <p className="text-sm text-gray-500">
                                                The record is currently being edited by {lockOwner}. Do you want to request access?
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                                <button
                                    type="button"
                                    className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:ml-3 sm:w-auto sm:text-sm"
                                    onClick={handleRequestAccess}
                                >
                                    Request Access
                                </button>
                                <button
                                    type="button"
                                    className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                                    onClick={() => setModalVisible(false)}
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default TroubleCallList;
